import React, { useState, useEffect, useContext, Fragment, useCallback, useRef } from "react";
import "./styles.css";

import { getappointmentData } from "../../actions/appointment";
import { SignalerCtx, LangCtx, localRecordingCtx } from "../../lib/context";
import OutgoingCall from "../common/callingModals/outgoingCallModal";
import Loader from "../../lib/ui/loader/Loader";
import Conference from "./conference";
// import InstaVC from "./libs/instavc";
import Roomclient from "./sdklib/Roomclient";
// import * as mediasoup from "mediasoup-client";
import getUserAgentData from "./sdklib/deviceInfo.js";
// import queryString from 'query-string';
import { toast } from 'react-toastify';
import { exitParticipantLogs } from "../../actions/appointment";
import { API } from 'aws-amplify';
import { recorder } from "../../../src/BrowserRecorder.js";
import axios from 'axios';
import { getSubdomain } from "../../lib/domain.js";
// const psl = require('psl');


const ConferenceLayout = (props) => {
    const { id, uid, role, history, payload, query_data } = props;

    // const { id, uid } = useParams();
    // const history = useHistory();
    // const { role } = useContext(RoleCtx);
    const { signaler } = useContext(SignalerCtx);
    const { l } = useContext(LangCtx);
    // const { payload } = useContext(PayLoadCtx);

    const [appointment, setAppointment] = useState(null);
    const [loading, setLoading] = useState(true);
    const [ogCall, setOGCall] = useState(null);
    const [instaVC, setInstaVC] = useState(null);
    const [callstatus, setCallStatus] = useState(l.connecting);
    const [localRecording, setLocalRecording] = useState(false)
    const [cloudRecording, setCloudRecording] = useState(false)

    // const query_data = queryString.parse(props.location.search);
    const ogCallRef = useRef(null);

    // const _domain = psl.parse(window.location.hostname);
    const _domain = getSubdomain(window.location.hostname);




    recorder.on('statusChanged', (newStatus) => {
        if (newStatus === 'stopped') {
            setLocalRecording(false);
        }
    });

    const startLocalRecording = async () => {
        try {
            const additionalAudioTracks = [];
            if (instaVC && instaVC._micProducer) {
                const micProducers = Object.values(instaVC._micProducer);
                // Ensure micProducers is an array and contains items
                if (Array.isArray(micProducers) && micProducers.length > 0) {
                    const micProducerVar = micProducers.find((p) => p && p.source === "mic");
                    if (micProducerVar && micProducerVar.track) {
                        additionalAudioTracks.push(micProducerVar.track);
                    }
                }
            }

            const roomname = (appointment?.doctorData?.firstName || "doctor") + '_' + (appointment?.patientData?.firstName || "patient");
            // Set this to the actual room name as needed
            recorder.startLocalRecording({
                instaVC,
                additionalAudioTracks,
                recordingMimeType: "video/webm;codecs=vp8,opus",
                roomname,
                setLocalRecording
            });

            if (instaVC && instaVC._consumers) {
                recorder.checkAudioConsumer(instaVC._consumers);
            }
        } catch (err) {
            console.error("Error during starting the recording! error:", err.message);
        }
    };



    const stopRecording = async () => {
        try {
            setLocalRecording(false)
            recorder.stopLocalRecording();
        }
        catch (e) {
            console.log("................", e)
        }
    };

    const startCloudRecording = async () => {
        try {
            setCloudRecording(true);
            let subdomain = _domain.subdomain ? _domain.subdomain : 'app'
            const botLink = `https://${subdomain}${process.env.REACT_APP_domainURL}/bot-link/${id}?record=true&name=bot&email=bot@yopmail.com`
            const fileName = `${appointment.doctorData.firstName}_${appointment.patientData.firstName}_${new Date().valueOf()}`;//_${new Date().valueOf()}
            let url = 'https://sfutestrecording.inmeet.ai/create-cloud-recording'
            let body = {
                roomId: id,
                botLink: botLink,
                userId: appointment.doctorId,
                bucket: process.env.REACT_APP_s3,
                project: process.env.REACT_APP_Project,
                recordingPath: `/recordings/${process.env.REACT_APP_Project}/${id}/${appointment.doctorId}`,
                bucketPath: `${process.env.REACT_APP_s3}/${process.env.REACT_APP_Project}/${appointment.clinicId}/${appointment.doctorId}/${id}`,
                videoName: fileName
            };


            let headers = {
                'Content-Type': 'application/json'
            };

            console.log("body", url, body)
            axios.post(url, body, { headers })
                .then((response) => console.log(response.data))
                .catch((error) => console.log('error:::: Create Error Recording!', error));

        } catch (err) {
            console.log('err:::: Create Error Recording!', err)
        }
    }

    const stopCloudRecording = async () => {
        try {
            setCloudRecording(false);

            let url = "https://sfutestrecording.inmeet.ai/stop-cloud-recording";


            let body = {
                instituteId: appointment.clinicId,
                meetingId: id
            }

            let headers = {
                'Content-Type': 'application/json'
            };

            console.log("body1", url, body)



            axios.post(url, body, { headers })
                .then((response) => { console.log('response', response.data) })
                .catch((error) => { console.log("Stop Recording Error", error) });


        } catch (err) {
            console.log('stopRecording====error', err);
        }
    }





    const updateCallStatus = () => {

        let body = {
            appointmentId: appointment.appointmentId,
            enterUTC: new Date().valueOf(),
            exitUTC: new Date().valueOf(),
            callStatus: false
        }
        exitParticipantLogs(body).then((res) => {

            console.log("updated", res)


        })
    }

    useEffect(() => {
        if (sessionStorage.getItem('reload')) {
            sessionStorage.clear();
            endCallRequest();
        } else {
            sessionStorage.setItem('reload', true);
        }

        return () => {
            sessionStorage.clear();
            // history.push("/");
        };
    }, []);

    useEffect(() => {
        if (id) {
            getappointmentData(id).then(res => {
                setLoading(false);
                // console.log("res ==== ", res);
                if (res.status) {
                    setAppointment(res.data);
                } else {
                    history.push("/");
                }
            }).catch(err => {
                console.log("err ==== ", err);
                if (API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setLoading(false);
                }
                history.push("/");
            })
        }
    }, [id])

    useEffect(() => {
        if (instaVC && instaVC !== null) {
            recorder.checkMicProducer(instaVC._micProducer);
            recorder.checkAudioConsumer(instaVC._consumers);
            // instaVC.on('remote-added', (streams) => {
            //     ogCallRef.current = null;
            //     setOGCall(null);
            // });
        }
    }, [instaVC])

    const setRedirect = async () => {
        console.log("ending::D", instaVC);
        if(instaVC){
            await instaVC.closeMeeting()
        }
        history.push("/");
    };
    useEffect(() => {
        if (appointment?.endTime) {
            let diff = new Date(appointment.endTime).getTime() - new Date().getTime();
            setTimeout(setRedirect, diff);
        }
    }, [appointment]);

    useEffect(() => {
        if (role === "D" && signaler && appointment && appointment.appointmentId && payload && payload.userId === appointment.doctorId) {
            ogCallRef.current = appointment.patientData;
            setOGCall(appointment.patientData);
            let doctor_obj = appointment.doctorData;
            doctor_obj['roomId'] = payload && payload.defaultRoom ? payload.defaultRoom : '';
            signaler.on('decline-request', () => {
                ogCallRef.current = null;
                setOGCall(null);
                history.push(`/doc-conf-settings/${id}/${uid}`);
            })
            signaler.on('accept-call', () => {
                ogCallRef.current = null;
                setOGCall(null);
                // setInstaVC(new InstaVC(l));
                const device = getUserAgentData();
                if (instaVC === null) {
                    setInstaVC(new Roomclient({ device }));
                }
                if (!appointment.ccStatus) updateCallStatus()
            })
            signaler.on('callreq-sent', () => {
                setCallStatus(l.calling);
            });
            signaler.sendCallRequest(doctor_obj, uid);
            return () => {
                signaler.off('decline-request', () => { });
                signaler.off('accept-call', () => { });
                signaler.off('callreq-sent', () => { });
                ogCallRef.current = null;
                setOGCall(null);
            };
        } else if (appointment && appointment.appointmentId && signaler === null) {
            // setInstaVC(new InstaVC(l));
            const device = getUserAgentData();
            console.log(query_data.record, query_data.record === true)
            if (instaVC === null) {
                let data = { device }
                console.log(query_data)
               
                const isTruthy = value => value === 'true' || value === true;
                if (isTruthy(query_data.record)) {
                    data.record = true;
                }
                if (isTruthy(query_data.headless)) {
                    data.headless = true;
                }
                console.log(data);
                // let temp = new Roomclient(data);
                // temp.connect();
                // setInstaVC(temp);
                setInstaVC(new Roomclient(data));
            }
        }
    }, [appointment, signaler]);

    useEffect(() => {
        if (ogCall !== null) {
            setTimeout(setEndCall, 40000);
        }
    }, [ogCall]);

    const setEndCall = useCallback(() => {
        if (ogCallRef.current !== null) {
            toast.warning(`${ogCall.firstName} ${l.patient_no_answer}`, {
                position: toast.POSITION.TOP_RIGHT
            })
            let _url = `/doc-conf-settings/${id}/${uid}`
            endCallRequest(_url);
        }
    }, [ogCall, id, uid])

    const endCallRequest = (url = "") => {
        if (signaler && appointment && appointment.doctorData) {
            signaler.cancelCallRequest(uid, appointment.doctorData);
        }
        ogCallRef.current = null;
        setOGCall(null)
        if (instaVC) {
            instaVC.clearConference()
        }
        history.push(url && url !== '' ? url : '/');
    }

    const roomId = payload && payload.defaultRoom ? payload.defaultRoom : appointment && appointment.doctorData && appointment.doctorData.defaultRoom ? appointment.doctorData.defaultRoom : '';
    console.log(appointment);
    return <Fragment>
        {loading ? <Loader /> :
            appointment !== null ? (
                <Fragment>
                    {ogCall !== null && (
                        <OutgoingCall
                            status={callstatus}
                            ogCall={ogCall !== null}
                            handleOgcall={endCallRequest}
                            userData={ogCall}
                        />
                    )}
                    {instaVC !== null && ogCall === null && (
                        <localRecordingCtx.Provider value={{ localRecording, startLocalRecording, stopRecording, cloudRecording, startCloudRecording, stopCloudRecording }}>
                            <Conference
                                appointmentData={appointment}
                                id={id}
                                instaVC={instaVC}
                                query_data={query_data}
                                roomId={roomId}
                                role={role}
                                payload={payload}
                            />
                        </localRecordingCtx.Provider>
                    )}
                </Fragment>
            ) : null
        }
    </Fragment>


    // return (
    //     <>
    //     <FileCtx.Provider value={{ selFile, setFileView }}>
    //         <div className="confContainer">
    //             <ConfHeader />
    //             <div className="confBody">
    //                 <div className={currentScreen !== null ? "conf169Box drtnCol" : "conf169Box"}>
    //                     {currentScreen === "SS" &&
    //                         <ScreenShare handleScreen={handleScreen} />
    //                     }
    //                     {currentScreen === "WB" &&
    //                         <WhiteBoard handleScreen={handleScreen} />
    //                     }
    //                     <div className={currentScreen !== null ? "confVideoContainer wrapBottom" : "confVideoContainer"} id="videoArea">
    //                         <RemoteVideoBlock mode={currentScreen} />
    //                         <LocalVideoBlock mode={currentScreen} />
    //                     </div>
    //                 </div>
    //             </div>
    //             <ConfFooter handleScreen={handleScreen} data={appointment} />
    //         </div>
    //     </FileCtx.Provider>
    //         {
    // selFile !== null && <UploadFileView open={selFile !== null} handleClose={() => setFileView(null)} data={selFile} />
    // }
    // {
    // ogCall !== null &&
    //     <OutgoingCall ogCall={ogCall !== null} handleOgcall={endCallRequest} userData={ogCall} />
    // }
    //     </>
    // )
}

export default ConferenceLayout
